import AchievementAdminList from 'components/achievement/AchievementAdminList.vue'
import AchievementBatchEdit from 'components/achievement/AchievementBatchEdit.vue'
import AchievementView from 'components/achievement/AchievementView.vue'
import AchievementTemplateList from 'components/achievement/AchievementTemplateList.vue'

// 后台成果管理
export let admin_achievement_list = {
  path: 'achievement/list',
  component: AchievementAdminList,
  meta: {auth: $user => $user.$$auth.admin_achievement},
}
export let admin_achievement_check_list = {
  path: 'achievement/check/list',
  component: AchievementAdminList,
  meta: {auth: $user => $user.$$auth.admin_achievement},
}
export let admin_achievement_view = {
  path: 'achievement/view',
  component: AchievementView,
  meta: {auth: $user => $user.$$auth.admin_achievement},
}
export let admin_achievement_check = {
  path: 'achievement/check',
  component: AchievementView,
  meta: {auth: $user => $user.$$auth.admin_achievement},
}
export let admin_achievement_template_list = {
  path: 'achievement/template/list',
  component: AchievementTemplateList,
  meta: {auth: $user => $user.$$auth.admin_achievement},
}
export let admin_achievement_batch_edit = {
  path: 'achievement/batch/edit',
  component: AchievementBatchEdit,
  meta: {auth: $user => $user.$$auth.admin_achievement},
}

export let admin_achievement_routes = [
  admin_achievement_view,
  admin_achievement_check_list,
  admin_achievement_check,
  admin_achievement_list,
  admin_achievement_template_list,
  admin_achievement_batch_edit,
]

export let admin_achievement_map = {
  admin_achievement_view,
  admin_achievement_check_list,
  admin_achievement_check,
  admin_achievement_list,
  admin_achievement_template_list,
  admin_achievement_batch_edit,
}



// WEBPACK FOOTER //
// ./src/router/routes/admin/achievement.js